import { InternationalRegion } from 'components/modal-dialog/international-links';
import { EXP_INTERNATIONAL_LINKS_URLS } from 'constants/urls';
import { UI_COUNTRY_CODE_LIST } from 'types/countries';
import { LOCALE_COMMON_PATHS } from 'types/locales';

export const EXP_REALTY_INTERNATIONAL_LINKS: InternationalRegion[] = [
  { // North America
    label: LOCALE_COMMON_PATHS.INTERNATIONAL_REGION_LABELS_NORTH_AMERICA,
    divisionLinks: [
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.CANADA,
        countryCode: UI_COUNTRY_CODE_LIST.CANADA,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_CANADA,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.UNITED_STATES,
        countryCode: UI_COUNTRY_CODE_LIST.UNITED_STATES,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_UNITED_STATES,
      },
    ],
  },
  { // CALA (Caribbean and Latin America)
    label: LOCALE_COMMON_PATHS.INTERNATIONAL_REGION_LABELS_CALA,
    divisionLinks: [
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.BRAZIL,
        countryCode: UI_COUNTRY_CODE_LIST.BRAZIL,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_BRAZIL,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.CHILE,
        countryCode: UI_COUNTRY_CODE_LIST.CHILE,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_CHILE,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.COLOMBIA,
        countryCode: UI_COUNTRY_CODE_LIST.COLOMBIA,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_COLOMBIA,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.DOMINICAN_REPUBLIC,
        countryCode: UI_COUNTRY_CODE_LIST.DOMINICAN_REPUBLIC,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_DOMINICAN_REPUBLIC,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.ECUADOR,
        countryCode: UI_COUNTRY_CODE_LIST.ECUADOR,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_ECUADOR,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.MEXICO,
        countryCode: UI_COUNTRY_CODE_LIST.MEXICO,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_MEXICO,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.PERU,
        countryCode: UI_COUNTRY_CODE_LIST.PERU,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_PERU,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.PUERTO_RICO,
        countryCode: UI_COUNTRY_CODE_LIST.PUERTO_RICO,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_PUERTO_RICO,
      },
    ],
  },
  { // EMEIA (Europe, Middle East, India, and Africa)
    label: LOCALE_COMMON_PATHS.INTERNATIONAL_REGION_LABELS_EMEIA,
    divisionLinks: [
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.UNITED_ARAB_EMIRATES,
        countryCode: UI_COUNTRY_CODE_LIST.UNITED_ARAB_EMIRATES,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_DUBAI,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.FRANCE,
        countryCode: UI_COUNTRY_CODE_LIST.FRANCE,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_FRANCE,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.GERMANY,
        countryCode: UI_COUNTRY_CODE_LIST.GERMANY,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_GERMANY,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.INDIA,
        countryCode: UI_COUNTRY_CODE_LIST.INDIA,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_INDIA,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.ISRAEL,
        countryCode: UI_COUNTRY_CODE_LIST.ISRAEL,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_ISRAEL,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.ITALY,
        countryCode: UI_COUNTRY_CODE_LIST.ITALY,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_ITALY,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.LUXEMBOURG,
        countryCode: UI_COUNTRY_CODE_LIST.LUXEMBOURG,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_LUXEMBOURG,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.NETHERLANDS,
        countryCode: UI_COUNTRY_CODE_LIST.NETHERLANDS,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_NETHERLANDS,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.POLAND,
        countryCode: UI_COUNTRY_CODE_LIST.POLAND,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_POLAND,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.PORTUGAL,
        countryCode: UI_COUNTRY_CODE_LIST.PORTUGAL,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_PORTUGAL,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.ROMANIA,
        countryCode: UI_COUNTRY_CODE_LIST.ROMANIA,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_ROMANIA,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.SOUTH_AFRICA,
        countryCode: UI_COUNTRY_CODE_LIST.SOUTH_AFRICA,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_SOUTH_AFRICA,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.SPAIN,
        countryCode: UI_COUNTRY_CODE_LIST.SPAIN,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_SPAIN,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.TURKIYE,
        countryCode: UI_COUNTRY_CODE_LIST.TURKIYE,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_TURKEY,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.UNITED_KINGDOM,
        countryCode: UI_COUNTRY_CODE_LIST.UNITED_KINGDOM,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_UNITED_KINGDOM,
      },
    ],
  },
  { // APAC (Asia Pacific)
    label: LOCALE_COMMON_PATHS.INTERNATIONAL_REGION_LABELS_APAC,
    divisionLinks: [
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.AUSTRALIA,
        countryCode: UI_COUNTRY_CODE_LIST.AUSTRALIA,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_AUSTRALIA,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.HONG_KONG,
        countryCode: UI_COUNTRY_CODE_LIST.HONG_KONG,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_HONG_KONG,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.JAPAN,
        countryCode: UI_COUNTRY_CODE_LIST.JAPAN,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_JAPAN,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.SOUTH_KOREA,
        countryCode: UI_COUNTRY_CODE_LIST.SOUTH_KOREA,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_SOUTH_KOREA,
      },
      {
        href: EXP_INTERNATIONAL_LINKS_URLS.NEW_ZEALAND,
        countryCode: UI_COUNTRY_CODE_LIST.NEW_ZEALAND,
        label: LOCALE_COMMON_PATHS.INTERNATIONAL_DIVISION_LABELS_NEW_ZEALAND,
      },
    ],
  },
] as const;